import type { IApply } from "@bbj-types/apply";
import { ModalOffer } from "@candidate/components/ModalOffer";
import { useGlobalContext } from "@root/context";
import type { IFormGenContext } from "node_modules/@artifact-management/json-dynamic-form/dist/types";
import { useMemo } from "react";

export interface IFormGenInputJobApplyModalProps {
  open: boolean;
  context: IFormGenContext | undefined;
  onConfirm: (result: IApply) => void;
  onCancel: () => void;
}

export const FormGenInputJobApplyModal = ({ open, context, onConfirm, onCancel }: IFormGenInputJobApplyModalProps) => {
  const { amps } = useGlobalContext();

  const amp = useMemo(() => {
    if (!amps) {
      return undefined;
    }
    return amps.find((amp) => amp.kind === "job" && amp.jobBoardDefault);
  }, [amps]);

  return (
    <ModalOffer
      title="Nouvelle candidature à une offre d'emploi"
      open={open}
      onConfirm={onConfirm}
      onCancel={onCancel}
      candidateId={context?.candidateId}
      isApply
      applyFollowUp
      defaultApplyValues={{ status: "success" }}
      managementProcess={amp?._id}
      disabledFields={{
        applyStatus: true,
      }}
    />
  );
};
